import { TOTAL_CLIENTS } from '@propertypal/shared/src/constants/products';
import { AgentShowcase } from '@propertypal/shared/src/types/agentShowcase';
import Button from '@propertypal/web-ui/src/buttons/Button';
import { SubHeading, Text } from '@propertypal/web-ui/src/typography';
import React from 'react';
import { Container, Wrapper, TextContent, LogoGrid, LogoGridItem, AgentLogo } from './Customers.style';

interface CustomersProps {
  data?: AgentShowcase['microsites'];
  dev?: boolean;
}

const Customers: React.FC<CustomersProps> = ({ data, dev }) => {
  return (
    <Container>
      <Wrapper>
        <TextContent>
          <SubHeading fontSize={60} align="center">
            With over <span>{TOTAL_CLIENTS}</span> {!dev ? `estate agent websites alone` : 'websites'}...
          </SubHeading>
          <Text fontSize={24} align="center">
            We&apos;re sure you&apos;ve already seen some of our work when navigating the web. Just take a look at some
            of our clients&apos; websites below:
          </Text>
        </TextContent>
        <LogoGrid>
          {data?.map((mircosite) => (
            <LogoGridItem
              key={mircosite.id}
              bgColour={mircosite.logo.backgroundColour}
              data-testid="customer-logo"
              href={mircosite.websiteUrl}
              target="_blank"
              rel="noreferrer"
            >
              <AgentLogo src={mircosite.logo.url} alt={mircosite.title} />
            </LogoGridItem>
          ))}
        </LogoGrid>
        <Button
          onClick={() => document.getElementById('getInTouch')?.scrollIntoView({ behavior: 'smooth' })}
          maxWidth="330px"
          testID="scroll-to-button"
        >
          Let&apos;s chat
        </Button>
      </Wrapper>
    </Container>
  );
};

export default Customers;
